import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class AuthLayoutComponent {}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/layouts/auth/auth-layout.component.ts